export const UserFeatures = {
    OptionTrading: 'order.trading.options',
    MutualFundTrading: 'order.trading.fund',
    BasicTrading: 'order.trading.basic',
    ViewDocuments: 'document.download.view',
    BulkDocumentDownload: 'document.download.bulk',
    GtxTrading: 'order.trading.gtx'
}
